import PaidIcon from '@mui/icons-material/Paid';

import { TransactionsList } from '@/view/transactions/TransactionsList';

export default {
  list: TransactionsList,
  icon: PaidIcon,
  recordRepresentation: 'reference',
};
